import { ChangeEvent, FC, PropsWithChildren } from "react";
import classes from './UserTableToolbar.module.scss';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

interface UserTableToolbarProps extends PropsWithChildren {
    globalFilterValue?: string,
    cityDropdown?: React.ReactNode,
    createButton?: React.ReactNode,
    onGlobalFilterChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

/** Показывает поиск и действия списка пользователей */
export const UserTableToolbar: FC<UserTableToolbarProps> = (props) => {
    const {
        globalFilterValue,
        onGlobalFilterChange,
        cityDropdown,
        createButton
    } = props;

    const showSearch = globalFilterValue !== undefined && onGlobalFilterChange;

    return (
        <div className={classes['table-toolbar']}>

            {showSearch && (
                <div className={classes['search-section']}>
                    <IconField
                        iconPosition="left"
                    >
                        <InputIcon className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Поиск"
                        />
                    </IconField>
                </div>
            )}

            <div className={classes['actions-section']}>
                {cityDropdown}
                {createButton}
            </div>

        </div>
    );
};